<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert
      variant="success"
      :show="!userData"
    >
      <h4 class="alert-heading">
        Data is loading...
      </h4>
    </b-alert>

    <template v-if="userData">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <b-card
            no-body
            class="card-employee-task"
          >
            <b-card-header
              class="details-header"
            >
              <b-card-title>
                Debtor Details:
                <small
                  title="Copy Debtor ID"
                  style="cursor: pointer;"
                  @click.stop.prevent="copyCode('copy-debtor-id')"
                >
                  {{ userData.data.id }}
                  <input
                    id="copy-debtor-id"
                    type="hidden"
                    :value="userData.data.id"
                  >
                </small>
                |
                <small
                  title="Copy Debtor ID"
                  style="cursor: pointer;"
                  @click.stop.prevent="copyCode('copy-bc-debtor-id')"
                >
                  {{ userData.data.bc_debtor_id }}
                  <input
                    id="copy-bc-debtor-id"
                    type="hidden"
                    :value="userData.data.bc_debtor_id"
                  >
                </small>
              </b-card-title>
              <b-button
                :to="{ name: 'debtor-edit', params: { id: userData.data.id } }"
                variant="primary"
              >
                {{ $t('DEBTIA_EDIT_DEBTOR') }}
              </b-button>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <user-view-user-info-card :user-data="userData" />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
          lg="12"
        >
          <debtor-details-portion :user-data="userData" />
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert,
  // BLink,
  BCard, BCardHeader, BCardTitle, BButton,
} from 'bootstrap-vue'
// import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import debtorStoreModule from '../debtorStoreModule'
import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
import DebtorDetailsPortion from './DebtorDetailsPortion.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    // BLink,
    BCard,
    BCardHeader,
    BCardTitle,
    BButton,
    // Local Components
    UserViewUserInfoCard,
    DebtorDetailsPortion,

    // InvoiceList,
  },
  data() {
    return {
      InvoiceList: [],
    }
  },
  setup() {
    const userData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-debtor'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, debtorStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-debtor/fetchDebtor', { id: router.currentRoute.params.id })
      .then(response => {
        userData.value = response.data
      })
      .catch(error => {
        if (error.response.status === 404) {
          userData.value = undefined
        }
      })

    return {
      userData,
    }
  },
  methods: {
    copyCode(id) {
      let codeToCopy = ''
      codeToCopy = document.querySelector(`#${id}`)
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
      try {
        document.execCommand('copy')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Text copied',
            icon: 'BellIcon',
          },
        })
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failed to copy texts!',
            icon: 'BellIcon',
          },
        })
      }
      /* unselect the range */
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  },
}
</script>

<style>
.details-header {
  padding: 10px 15px 10px 15px !important;
}
</style>
